import { CustomerList, SimpleSquareDevice } from "../models/Event";
import { BuildPortalUri } from "./BuildUri";
import portalAxios from "./portalAxios";

class SquareDeviceEndpoints {
    static async createSquareDeviceForClient(clientId: number, name: string) {
        return (
            await portalAxios.post<SimpleSquareDevice>(
                BuildPortalUri(`/square-device/client/{clientId}`, {
                    clientId,
                }),
                { name },
            )
        ).data;
    }

    static async getSquareDevicesForClient(clientId: number) {
        return (
            await portalAxios.get<SimpleSquareDevice[]>(
                BuildPortalUri(`/square-device/client/{clientId}`, {
                    clientId,
                }),
            )
        ).data;
    }

    static async getSquareDeviceById(clientId: number, squareDeviceId: number) {
        return (
            await portalAxios.get<SimpleSquareDevice>(
                BuildPortalUri(
                    `/square-device/client/{clientId}/device/{squareDeviceId}`,
                    { clientId, squareDeviceId },
                ),
            )
        ).data;
    }

    static async deleteSquareDeviceForClient(
        clientId: number,
        squareDeviceId: number,
    ) {
        return await portalAxios.delete(
            BuildPortalUri(
                `/square-device/client/{clientId}/device/{squareDeviceId}`,
                { clientId, squareDeviceId },
            ),
        );
    }
}

export default SquareDeviceEndpoints;
